import React from 'react';

import RightArrow from '@/components/Icons/icons/RightArrow';

import OnboardingCommonModal from './OnboardingCommonModal';

const OnboardingEndModal = ({ show, onClose }: { show: boolean; onClose: () => void }) => {
  return (
    <OnboardingCommonModal
      show={show}
      onClose={onClose}
      icon="🚀"
      iconBgColor="var(--secondary-surface-yellow)"
      title={<p className="px-2 leading-8">There is a lot more you can achieve with SARAL!</p>}
      description={
        <div className="leading-7">
          <p className="mb-4">
            Our mission is to help you build an owned influencer community that keeps promoting your brand non-stop.
            <br />
            We&apos;ve got an onboarding course ready to go for you inside the app. Explore that and keep building some
            influencer momentum!
          </p>
          <p>Reach out to us in the support chat on the bottom right if you have questions.</p>
        </div>
      }
      buttonText={
        <p className="text-sm font-medium flex items-center gap-2">
          Let&apos;s Get Started <RightArrow color="white" />{' '}
        </p>
      }
    />
  );
};

export default OnboardingEndModal;
